import { ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { BusinessComponentService } from '../business-component.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { ICreateBusinessComponentRequest } from '../models/business-component.model';
import { CustomDropDown } from 'src/app/shared/models/custom-dropdown.model';
import { RightSideDrawerService } from 'src/app/shared/right-side-drawer/right-side-drawer.service';
import { ToastrService } from '@kpmg-tax/ui';
import { BUSINESSCOMPONENTTYPE } from 'src/app/shared/constants/app-constants';

@Component({
  selector: 'rcn-create-business-component',
  templateUrl: './create-business-component.component.html',
  styleUrls: ['./create-business-component.component.scss']
})

export class CreateBusinessComponent {
  selectBcTypeText = 'Select BC Type';
  bcTypeOptions: CustomDropDown[] = [
    { id: 1, value: 'Process', isDisabled: false },
    { id: 2, value: 'Product', isDisabled: false },
    { id: 3, value: 'Software', isDisabled: false }
  ];
  createBusinessComponentForm: FormGroup;
  businessComponentNameControl = new FormControl('', []);
  bcQualifiedPercentageControl = new FormControl(100,
    [
      Validators.pattern('^[0-9]+(.[0-9]{1,2})?$'),
      Validators.min(0),
      Validators.max(100),
    ]);
    businessComponentNumberControl = new FormControl('', [
      Validators.pattern('^[a-zA-Z0-9]+$')
    ]);

  dropdownSettings: IDropdownSettings;

  @Input() engagementId: number = 0;

  @Output() closeBCDialog = new EventEmitter<void>();

  clientProjects: { clientProjectId: number, clientProjectName: string, isSelected: boolean }[] = [];
  clientProjectsAdded: { clientProjectId: number, clientProjectName: string }[] = [];
  showBCNameError = false;
  showBCNumberError = false;
  bcTypeSelected: string = '';
  showBCQualifiedPercentageError = false;

  constructor(private formBuilder: FormBuilder, private bcService: BusinessComponentService, public rightSideDrawerService: RightSideDrawerService, private _toastrService: ToastrService,) { }

  ngOnInit() {
    this.dropdownSettings = {
      singleSelection: false,
      defaultOpen: false,
      idField: 'clientProjectId',
      textField: 'clientProjectName',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true
    };
    // this.buildForm();
    this.getStandAloneClientProjects();
  }

  markBCNameAsUntouched() {
    if (this.businessComponentNameControl.value && this.businessComponentNameControl.value.toString().length > 0) {
      this.businessComponentNameControl.markAsUntouched();
      this.bcService.checkBusinessComponentName(this.engagementId, this.businessComponentNameControl.value).subscribe(isUniqueBCName => {
        this.showBCNameError = !isUniqueBCName ? true : false;
        if (this.showBCNameError)
          this.businessComponentNameControl.markAsTouched();
      });
    }
  }

onBCQualifiedPercentageToggle(toggleState: boolean) {
  const newValue = toggleState ? 100 : 0;
  this.bcQualifiedPercentageControl.setValue(newValue);
  this.bcQualifiedPercentageControl.markAsTouched();
  this.showBCQualifiedPercentageError = false;
}

  markBCNumberAsUntouched() {
    this.businessComponentNumberControl.markAsUntouched();
    this.showBCNumberError = false;
    if (this.businessComponentNumberControl.value && this.businessComponentNumberControl.value.toString().length > 0) {
      this.bcService.checkBusinessComponentNumber(this.engagementId, this.businessComponentNumberControl.value).subscribe(isUniqueBCName => {
        this.showBCNumberError = !isUniqueBCName ? true : false;
        if (this.showBCNumberError)
          this.businessComponentNumberControl.markAsTouched();
      });
    }
  }

  buildForm() {
    this.createBusinessComponentForm = this.formBuilder.group({
      businessComponentNameControl: ['', []],
      bcQualifiedPercentageControl: [100,
        [
          Validators.pattern('^[0-9]+(.[0-9]{1,2})?$'),
          Validators.min(0),
          Validators.max(100),
        ],]
    });
  }

  isValidForm(): boolean {
    return this.businessComponentNameControl.value && this.businessComponentNameControl.value.toString().length > 0 &&
      this.businessComponentNameControl.valid &&
      this.businessComponentNumberControl.valid &&
      // this.bcQualifiedPercentageControl.value && this.bcQualifiedPercentageControl.valid &&
      this.clientProjectsAdded.length > 0 && this.bcTypeSelected.length > 0 &&
      !this.showBCNameError && !this.showBCNumberError && !this.showBCQualifiedPercentageError ? true : false;
  }

  getStandAloneClientProjects(): void {
    this.bcService.getStandaloneClientProjects(this.engagementId).subscribe(response => {
      this.clientProjects = response
        ? response
            .filter(cp =>            
              cp.clientProjectName?.trim().toLowerCase() !== 'non-business component time'
            )
            .map(cp => ({
              clientProjectId: cp.clientProjectId,
              clientProjectName: cp.clientProjectName,
              isSelected: false
            }))
        : [];
    });
  }

  createBusinessComponent(): void {
    const request: ICreateBusinessComponentRequest = {
      engagementId: this.engagementId,
      businessComponentName: btoa(this.businessComponentNameControl.value),
      bCQualifiedPercenatge: Number(this.bcQualifiedPercentageControl.value),
      clientProjectIds: this.clientProjectsAdded.map(x => x.clientProjectId),
      businessComponentNumber: btoa(this.businessComponentNumberControl.value),
      businessComponentType: isNaN(Number(this.bcTypeSelected)) ? 0 : Number(this.bcTypeSelected)
    }
    this.bcService.createBusinessComponent(request).subscribe(response => {
      if (response) {
        this._toastrService.setSuccessMessage('Business Component created successfully');
        this.bcService.fetchProjectsAndBusinessComponents(this.engagementId).subscribe();
      }
      this.showCreateBusinessComponentDialog();
    })
  }

  selectBCType(selectionChangeEvent: Event) {
    if (selectionChangeEvent.target) {
      const targetElement: any = selectionChangeEvent.target;
      this.bcTypeSelected = targetElement.value;
    }
  }

  closeModel() {
    this.clientProjects = [];
    this.clientProjectsAdded = [];
    this.showBCNameError = false;
    this.showBCNumberError = false;
    this.showBCQualifiedPercentageError = false;
    this.closeBCDialog.emit()
  }

  ngDestroy() {
  }

  showCreateBusinessComponentDialog(): void {
    this.rightSideDrawerService.openRightSideDrawer('manage-business-component-screen', 'Manage Business Components', this.engagementId);
  }
}
